import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

const createActions = storeName => {
    const types = getTypes(storeName);
    const setMetadata = createAction(types.SET_METADATA);
    const checkPinCode = createAction(types.CHECK_PIN_CODE);
    const setPinCodeStatus = createAction(types.SET_PIN_CODE_STATUS);
    const setIsPinCodeOrDOBValid = createAction(types.SET_IS_PIN_CODE_OR_DOB_VALID);

    return {
        ...dynaForms.getActions(storeName),
        setMetadata,
        checkPinCode,
        setPinCodeStatus,
        setIsPinCodeOrDOBValid,
    };
};

export default createActions;
